export enum InsuranceRelationEnum {
  ValidValue  = 'D8885F55-336C-4838-B345-C4A2A6E4F6BB',
  Self        = '00000045-1000-0000-0000-000000000001',
  Spouse      = '00000045-1000-0000-0000-000000000002',
  Child       = '00000045-1000-0000-0000-000000000003',
  Employee       = '00000045-1000-0000-0000-000000000004',
  HandicappedDependent       = '00000045-1000-0000-0000-000000000005',
  SignificantOther       = '00000045-1000-0000-0000-000000000006',
  InjuredPlaintiff       = '00000045-1000-0000-0000-000000000007',
  LifePartner       = '00000045-1000-0000-0000-000000000008',
  Dependent       = '00000045-1000-0000-0000-000000000009',

}
